import { render, staticRenderFns } from "./GiftBoxPayment.vue?vue&type=template&id=57d4e442&scoped=true&"
import script from "./GiftBoxPayment.vue?vue&type=script&lang=js&"
export * from "./GiftBoxPayment.vue?vue&type=script&lang=js&"
import style0 from "./GiftBoxPayment.vue?vue&type=style&index=0&id=57d4e442&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d4e442",
  null
  
)

export default component.exports